import React, { Component } from 'react'

export default class Header extends Component {
  render() {
    return (
      <header>
        <h1>Games list</h1>
      </header>
    )
  }
}
